import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface SpotAvailabilityProps {
  isAvailable: boolean;
  isUpdating: boolean;
  onAvailabilityChange: (value: string) => void;
}

const SpotAvailability = ({ 
  isAvailable, 
  isUpdating, 
  onAvailabilityChange 
}: SpotAvailabilityProps) => {
  return (
    <div className="mt-4">
      <Select
        defaultValue={isAvailable ? "online" : "offline"}
        onValueChange={onAvailabilityChange}
        disabled={isUpdating}
      >
        <SelectTrigger>
          <SelectValue placeholder="Set availability" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="online">Online</SelectItem>
          <SelectItem value="offline">Unavailable</SelectItem>
          <SelectItem value="booked">Booked</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default SpotAvailability;